/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cutoffLabel: NonNullable<unknown> }} Booking_Error_Cutoff_ClosedInputs */

const en_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bookings for this date closed at ${i?.cutoffLabel} the day before.`)
};

const es_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las reservas para esta fecha cerraron a las ${i?.cutoffLabel} del día anterior.`)
};

const de_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buchungen für dieses Datum waren nur bis zum Vortag um ${i?.cutoffLabel} möglich.`)
};

const zh_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`该日期的预约已于前一天 ${i?.cutoffLabel} 截止。`)
};

const ar_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أُغلق الحجز لهذا التاريخ في الساعة ${i?.cutoffLabel} من اليوم السابق.`)
};

const fr_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les réservations pour cette date ont fermé la veille à ${i?.cutoffLabel}.`)
};

const vi_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Việc đặt lịch cho ngày này đã đóng lúc ${i?.cutoffLabel} ngày hôm trước.`)
};

const sw_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uwekaji nafasi kwa tarehe hii ulifungwa saa ${i?.cutoffLabel} siku iliyotangulia.`)
};

const th_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การจองสำหรับวันที่นี้ปิดไปแล้วเมื่อเวลา ${i?.cutoffLabel} ของวันก่อนหน้า`)
};

const bs_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezervacije za ovaj datum zatvorene su dan ranije u ${i?.cutoffLabel}.`)
};

const ja_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この日付の予約受付は前日の${i?.cutoffLabel}に締め切られました。`)
};

const ko_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이 날짜의 예약은 전날 ${i?.cutoffLabel}에 마감되었습니다.`)
};

const pt_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As reservas para esta data encerraram às ${i?.cutoffLabel} do dia anterior.`)
};

const it_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le prenotazioni per questa data si sono chiuse alle ${i?.cutoffLabel} del giorno prima.`)
};

const sv_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bokningar för detta datum stängde dagen innan kl. ${i?.cutoffLabel}.`)
};

const nl_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Boekingen voor deze datum sloten de dag ervoor om ${i?.cutoffLabel}.`)
};

const da_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bookinger til denne dato lukkede dagen før kl. ${i?.cutoffLabel}.`)
};

const nb_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestillinger for denne datoen stengte dagen før kl. ${i?.cutoffLabel}.`)
};

const fi_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tämän päivän varaukset sulkeutuivat edellisenä päivänä klo ${i?.cutoffLabel}.`)
};

const pl_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezerwacje na ten dzień zamknięto poprzedniego dnia o ${i?.cutoffLabel}.`)
};

const ru_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бронирование на эту дату закрылось накануне в ${i?.cutoffLabel}.`)
};

const tr_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu tarih için rezervasyonlar bir önceki gün saat ${i?.cutoffLabel} itibarıyla kapandı.`)
};

const hi_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस तारीख की बुकिंग एक दिन पहले ${i?.cutoffLabel} पर बंद हो गई थी।`)
};

const id_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pemesanan untuk tanggal ini ditutup pukul ${i?.cutoffLabel} sehari sebelumnya.`)
};

const ms_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempahan untuk tarikh ini ditutup pada pukul ${i?.cutoffLabel} sehari sebelumnya.`)
};

const cs_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezervace na tento den byly uzavřeny předchozí den v ${i?.cutoffLabel}.`)
};

const el_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Οι κρατήσεις για αυτή την ημερομηνία έκλεισαν στις ${i?.cutoffLabel} της προηγούμενης ημέρας.`)
};

const he_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ההזמנות לתאריך הזה נסגרו ביום הקודם בשעה ${i?.cutoffLabel}.`)
};

const af_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besprekings vir hierdie datum het die vorige dag om ${i?.cutoffLabel} gesluit.`)
};

const hu_booking_error_cutoff_closed = /** @type {(inputs: Booking_Error_Cutoff_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erre a napra a foglalás az előző napon ${i?.cutoffLabel}-kor lezárult.`)
};

/**
* | output |
* | --- |
* | "Bookings for this date closed at {cutoffLabel} the day before." |
*
* @param {Booking_Error_Cutoff_ClosedInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_error_cutoff_closed = /** @type {((inputs: Booking_Error_Cutoff_ClosedInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Error_Cutoff_ClosedInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_error_cutoff_closed(inputs)
	if (locale === "de") return de_booking_error_cutoff_closed(inputs)
	if (locale === "zh") return zh_booking_error_cutoff_closed(inputs)
	if (locale === "ar") return ar_booking_error_cutoff_closed(inputs)
	if (locale === "fr") return fr_booking_error_cutoff_closed(inputs)
	if (locale === "vi") return vi_booking_error_cutoff_closed(inputs)
	if (locale === "sw") return sw_booking_error_cutoff_closed(inputs)
	if (locale === "th") return th_booking_error_cutoff_closed(inputs)
	if (locale === "bs") return bs_booking_error_cutoff_closed(inputs)
	if (locale === "ja") return ja_booking_error_cutoff_closed(inputs)
	if (locale === "ko") return ko_booking_error_cutoff_closed(inputs)
	if (locale === "pt") return pt_booking_error_cutoff_closed(inputs)
	if (locale === "it") return it_booking_error_cutoff_closed(inputs)
	if (locale === "sv") return sv_booking_error_cutoff_closed(inputs)
	if (locale === "nl") return nl_booking_error_cutoff_closed(inputs)
	if (locale === "da") return da_booking_error_cutoff_closed(inputs)
	if (locale === "nb") return nb_booking_error_cutoff_closed(inputs)
	if (locale === "fi") return fi_booking_error_cutoff_closed(inputs)
	if (locale === "pl") return pl_booking_error_cutoff_closed(inputs)
	if (locale === "ru") return ru_booking_error_cutoff_closed(inputs)
	if (locale === "tr") return tr_booking_error_cutoff_closed(inputs)
	if (locale === "hi") return hi_booking_error_cutoff_closed(inputs)
	if (locale === "id") return id_booking_error_cutoff_closed(inputs)
	if (locale === "ms") return ms_booking_error_cutoff_closed(inputs)
	if (locale === "cs") return cs_booking_error_cutoff_closed(inputs)
	if (locale === "el") return el_booking_error_cutoff_closed(inputs)
	if (locale === "he") return he_booking_error_cutoff_closed(inputs)
	if (locale === "af") return af_booking_error_cutoff_closed(inputs)
	if (locale === "hu") return hu_booking_error_cutoff_closed(inputs)
	return en_booking_error_cutoff_closed(inputs)
});